import { CloudOff } from 'lucide-react';
import { fechaExacta, relativo } from './tiempo';

// «Esto que estás viendo es de antes.»
//
// Va con `useDatosDeTrabajo`, y existe para que la regla no dependa de que
// cada pantalla se acuerde de redactarla: un dato de caché se anuncia
// SIEMPRE, con su hora. Enseñar una lista vieja como si fuera de ahora es
// peor que no enseñar nada — quien la lee decide sobre existencias que ya
// cambiaron y ni siquiera sabe que debería dudar.
//
// La hora relativa («hace 2 horas») es la que se entiende de un vistazo con
// guantes; la exacta va al lado, porque a la hora de reclamar una
// diferencia «hace 2 horas» no sirve.
export default function AvisoCopiaLocal({ momento, que = 'Estos datos' }) {
  if (!momento) return null;
  return (
    <div role="status"
         className="flex items-start gap-2 rounded-lg border border-amber-300
                    bg-amber-50 px-3 py-2 text-sm text-amber-900">
      <CloudOff className="h-4 w-4 shrink-0 mt-0.5" aria-hidden="true" />
      <span>
        <span className="font-semibold">
          Sin conexión: {que.toLowerCase()} son la copia guardada en el
          teléfono, de {relativo(momento)}.
        </span>{' '}
        <span className="text-amber-800">
          ({fechaExacta(momento)}) Lo que hagas se guarda y se manda al
          recuperar señal, pero lo que ves puede haber cambiado.
        </span>
      </span>
    </div>
  );
}
